
import React from 'react';
import { WifiHigh, Battery, Signal } from 'lucide-react';

interface IPhoneFrameProps {
  image: string;
  alt: string;
  isMobile?: boolean;
}

const IPhoneFrame: React.FC<IPhoneFrameProps> = ({ 
  image, 
  alt, 
  isMobile = false 
}) => {
  const frameWidth = isMobile ? 'w-64' : 'w-[280px]';
  const dynamicIslandWidth = isMobile ? 'w-20' : 'w-24';
  const dynamicIslandHeight = isMobile ? 'h-6' : 'h-7';
  const dynamicIslandTop = isMobile ? 'top-2' : 'top-3';
  const paddingFrame = isMobile ? 'p-2' : 'p-3';
  const screenPadding = isMobile ? 'pt-8 pb-2' : 'pt-12 pb-3';
  const statusBarIconSize = isMobile ? 12 : 14;
  const statusBarTextSize = isMobile ? 'text-xs' : 'text-sm';

  return (
    <div className={`px-4 md:px-6 ${isMobile ? 'pb-6' : 'pb-8'}`}>
      <div className={`relative mx-auto ${frameWidth}`}>
        {/* Phone frame - single color, thinner */}
        <div className={`bg-gray-300 rounded-[2rem] p-1 shadow-md`}>
          {/* Screen */}
          <div className="bg-white rounded-[1.75rem] overflow-hidden relative">
            {/* Status Bar - aligned with dynamic island */}
            <div className={`absolute ${dynamicIslandTop} left-0 right-0 flex justify-between items-center px-6 z-20 ${statusBarTextSize} text-black font-medium`}>
              {/* Left side - Time without AM */}
              <div className="flex items-center">
                <span>9:41</span>
              </div>
              
              {/* Right side - iOS style icons */}
              <div className="flex items-center space-x-1">
                <Signal size={statusBarIconSize} className="fill-current" />
                <WifiHigh size={statusBarIconSize} className="fill-current" />
                <Battery size={statusBarIconSize} className="fill-current" />
              </div>
            </div>

            {/* Dynamic Island / Notch */}
            <div className={`absolute ${dynamicIslandTop} left-1/2 transform -translate-x-1/2 ${dynamicIslandWidth} ${dynamicIslandHeight} bg-black rounded-full z-10`}></div>
            
            {/* Screenshot */}
            <div className={screenPadding}>
              <img 
                src={image}
                alt={alt}
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IPhoneFrame;
